// src/lib/demoContentVersion.js — the one scenario-content version string,
// shared by the server's cached-answer key (api/_lib/demo-cache.js, which
// imports it the same direction api/ already imports every other pure src/lib
// helper — src/lib/nameMatch.js is the established precedent) and the
// browser's own business-list/entity cache reset on demo entry
// (src/lib/demoCacheReset.js).
//
// Bump this whenever the seeded scenario content changes in a way that could
// change what a cached answer OR a cached business-list/entity read should
// say (a reseed that moves the primary scenario, an archived/cancelled/
// superseded retirement that changes what "current" means) — both the
// server's cached-answer rows and the browser's IndexedDB/localStorage
// caches keyed under the old version become unconditional misses.
export const DEMO_CONTENT_VERSION = 'eighty-days-v2'
